import MovieFilterIcon from '@mui/icons-material/MovieFilter';

export const AnimationIcon = () => <MovieFilterIcon />;
